import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { observer } from "mobx-react";
import TabNavigation from "Components/common/TabNavigation";
import ConnectedAccountsRouting from "../Crm/ConnectedAccountsRouting";
import ConnectEmailButton from "./ConnectEmailButton";
import { linkedInReplyState } from "./LinkedInAccounts/state";
import ConnectedLinkedInButton from "./LinkedInAccounts/ConnectedLinkedInButton";
import BulkCsvConnect from "../ConnectInbox/BulkCsvConnect";
import connectedInboxStore from "../ConnectInbox/store";
export const CONNECTED_ACCOUNTS_LIST = [
  {
    name: "Email",
    id: "email",
    path: "email"
  },
  {
    name: "LinkedIn",
    id: "linkedin",
    path: "linkedin"
  },
  {
    name: "Sequences",
    id: "sequences",
    path: "sequences"
  }
];

const ConnectedAccounts = observer((props = {}) => {
  const [showEmailConfigure, setShowEmailConfigure] = useState(false);
  const [showSmtpImapConnect, setSmtpImapConnect] = useState(false);
  const [showBulkCsvConnect, setShowBulkCsvConnect] = useState(false);
  const [activeTab, setActiveTab] = useState("");
  const location = useLocation();

  const openConnectSmtpImapChoice = () => setShowBulkCsvConnect(true);

  const reloadInboxAfterBulkConnect = () => {
    connectedInboxStore.setLoading(true);
    connectedInboxStore.getAccountDetails(true);
  };

  const emailProps = {
    showEmailConfigure,
    showSmtpImapConnect,
    setSmtpImapConnect,
    setShowEmailConfigure,
    openConnectSmtpImapChoice
  };

  useEffect(() => {
    const tempActiveTab = location?.pathname?.split("/").pop();
    setActiveTab(tempActiveTab);
  }, [location]);

  return (
    <div className="connectedAccountsView">
      <div className="connectedAccountsHeader">
        {!showEmailConfigure &&
          !showSmtpImapConnect &&
          !linkedInReplyState?.showConfigure && (
            <TabNavigation tabList={CONNECTED_ACCOUNTS_LIST} />
          )}
        {activeTab === "email" && <ConnectEmailButton {...emailProps} />}
        {/* {Hiding it As Per prem's Instructions. We can enable it in future if needed } */}
        {/* {activeTab === "linkedin" && !linkedInReplyState?.showConfigure && (
          <ConnectedLinkedInButton />
        )} */}
      </div>
      <ConnectedAccountsRouting {...props} {...emailProps} />
      {showBulkCsvConnect && (
        <BulkCsvConnect
          onClose={() => setShowBulkCsvConnect(false)}
          onSingleAccount={() => {
            setShowBulkCsvConnect(false);
            setSmtpImapConnect(true);
          }}
          reloadInbox={reloadInboxAfterBulkConnect}
        />
      )}
    </div>
  );
});

export default ConnectedAccounts;
export { ConnectedAccounts };
